import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SteeringWheelFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM12 9.32C13.14 9.32 14.16 10.1 14.5 11.16H17.22C16.82 8.64 14.62 6.66 12 6.66C9.4 6.66 7.18 8.64 6.78 11.16H9.5C9.84 10.1 10.86 9.32 12 9.32ZM4.82 12.76C5.2 16.1 7.88 18.8 11.2 19.18V14.46C10.4 14.2 9.76 13.56 9.5 12.76H4.82ZM12.8 14.46V19.18C16.12 18.8 18.8 16.1 19.18 12.76H14.5C14.24 13.56 13.6 14.2 12.8 14.46Z" />
    </SvgIcon>
  );
});
